"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var getAriaLabelForVideoPlayer_1 = __importDefault(require("../utils/getAriaLabelForVideoPlayer"));

var loadOrPlayOrPause_1 = __importDefault(require("../utils/loadOrPlayOrPause"));

var PlayerError_1 = __importDefault(require("../utils/PlayerError"));

var time_1 = require("../utils/time");

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var handleClick = function handleClick(e, controller, playerState, streamInfo, throwError, setPlayQueued) {
  try {
    e.preventDefault();
    loadOrPlayOrPause_1["default"](controller, playerState, streamInfo, {
      autoPlay: true
    }, setPlayQueued);
  } catch (err) {
    throwError(new PlayerError_1["default"](err.message, {
      innerError: err,
      fatal: true
    }));
  }
};

var StartUiVod = function StartUiVod(_a, context) {
  var controller = _a.controller,
      playerState = _a.playerState,
      streamInfo = _a.streamInfo,
      loaderVisible = _a.loaderVisible,
      duration = _a.duration,
      setPlayQueued = _a.setPlayQueued;
  var resolvedDuration = duration > 0 ? duration : streamInfo ? streamInfo.duration : 0;
  return withTheme_1["default"](context.theme, {
    'ui-container': true,
    'ui-container--visible': !loaderVisible,
    'ui-container--simple': true
  })(React.createElement("div", {
    onClick: function onClick(e) {
      return controller && handleClick(e, controller, playerState, streamInfo, context.throwError, setPlayQueued);
    }
  }, streamInfo && streamInfo.liveNow ? withTheme_1["default"](context.theme, 'live__splash')(React.createElement("span", null, "Direkt")) : null, withTheme_1["default"](context.theme, {
    'play-pause-button-simple': true,
    'play-pause-button-simple--loaded': resolvedDuration > 0
  })(React.createElement("button", {
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    "aria-label": getAriaLabelForVideoPlayer_1["default"](streamInfo, resolvedDuration),
    "data-rt": "start-ui-btn"
  }, resolvedDuration > 0 && withTheme_1["default"](context.theme, 'play-pause-buttom-simple__text')(React.createElement("span", null, time_1.formatToHoursAndMinutes(resolvedDuration)))))));
};

StartUiVod.contextTypes = {
  theme: PropTypes.object
};
exports["default"] = StartUiVod;